import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { FileText, BarChart, Briefcase, BookOpen } from 'lucide-react';
export function About() {
  const handleViewBio = () => {
    window.open('https://heyzine.com/flip-book/a1887f94c2.html', '_blank');
  };
  const handleViewSwot = () => {
    window.open('https://heyzine.com/flip-book/2127181eed.html', '_blank');
  };
  const handleViewDossier = () => {
    window.open('https://heyzine.com/flip-book/e8b763b9b8.html', '_blank');
  };
  const handleViewLeadership = () => {
    window.open('https://heyzine.com/flip-book/dd0ca5d47a.html', '_blank');
  };
  return <Section id="about" background="white" data-id="element-11" data-mp="3himz1l60md20">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start" data-id="element-12" data-mp="3hhd0yvz5x4vd">
        <div className="lg:col-span-4" data-id="element-13" data-mp="3miitotstos4w">
          <FadeIn data-id="element-14" data-mp="3mjkis26obf5m">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 border-l-4 border-[#1e3a8a] pl-4" data-id="element-15" data-mp="3mfwov1xbgqqd">
              About Me
            </h2>
          </FadeIn>
        </div>

        <div className="lg:col-span-8 space-y-6" data-id="element-16" data-mp="2lssb3qkvley6">
          <div className="space-y-6 text-lg text-gray-600 leading-relaxed" data-id="element-17" data-mp="2gse50e2u4f2s">
            <FadeIn delay={0.1} data-id="element-18" data-mp="2guh19fukz4fy">
              <p data-id="element-19" data-mp="2cpr6jubnrvwm">
                Enterprise program leader driving large-scale transformation
                across commercial and federal, healthcare, and technology
                environments. Proven ability to translate strategy into
                executable roadmaps, standardize governance, and deliver
                complex, multi-stakeholder initiatives using agile and SDLC
                frameworks.
              </p>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-20" data-mp="2vn249ahn6h9y">
              <p data-id="element-21" data-mp="2qqtwii5rxqct">
                My expertise spans portfolio oversight, cross-functional
                alignment, risk management, and ISO-regulated environments. I
                have led portfolios exceeding $50M, managed teams of up to 40+
                professionals, and partnered closely with executive leadership
                to drive digital and business transformation. My work has
                resulted in measurable outcomes including cost reductions of up
                to 75%, 30% operational efficiency gains, and significant
                improvements in delivery timelines and stakeholder alignment.
              </p>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-22" data-mp="1cr6qgxtvj3y">
              <p data-id="element-23" data-mp="3jkguoxg4xx1w">
                Recognized for building high-performing teams, strengthening PMO
                structures, and delivering measurable operational impact. I am
                known for strong governance, clear decision-making, and the
                ability to navigate complex stakeholder environments while
                keeping teams focused on outcomes.
              </p>
            </FadeIn>
          </div>

          <FadeIn delay={0.4} data-id="element-24" data-mp="18t7146rs2qas">
            <div className="pt-6 border-t border-gray-200" data-id="element-25" data-mp="1cuad2i6pg26q">
              <h3 className="text-xl font-semibold text-gray-900 mb-4" data-id="element-26" data-mp="1ctqur0d57bs6">
                Professional Resources
              </h3>
              <div className="flex flex-col sm:flex-row gap-4 flex-wrap" data-id="element-27" data-mp="2x9yni7tkp6om">
                <Button variant="secondary" onClick={handleViewBio} className="shadow-md hover:shadow-lg transition-shadow" data-id="element-28" data-mp="2tckikscxdl2f">
                  <FileText className="w-5 h-5 mr-2" data-id="element-29" data-mp="329uqq4ug4u34" />
                  Executive Bio
                </Button>
                <Button variant="secondary" onClick={handleViewSwot} className="shadow-md hover:shadow-lg transition-shadow" data-id="element-30" data-mp="3h2eu96lid3l3">
                  <BarChart className="w-5 h-5 mr-2" data-id="element-31" data-mp="3q07806bl036d" />
                  SWOT Assessment
                </Button>
                <Button variant="secondary" onClick={handleViewDossier} className="shadow-md hover:shadow-lg transition-shadow" data-id="element-32" data-mp="3l02sojmetehq">
                  <Briefcase className="w-5 h-5 mr-2" data-id="element-33" data-mp="1qq8xhsfpqxzu" />
                  Strategic Executive Dossier
                </Button>
                <Button variant="secondary" onClick={handleViewLeadership} className="shadow-md hover:shadow-lg transition-shadow" data-id="element-34" data-mp="1x3lhaww4nzyv">
                  <BookOpen className="w-5 h-5 mr-2" data-id="element-35" data-mp="272u7denvgufy" />
                  Leadership Philosophy
                </Button>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </Section>;
}